import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import GeoMaster from "./MastersTabs.jsx/GeoMaster";
import UserMaster from "./MastersTabs.jsx/UserMaster";


const Masters = () => {

  return (
    <div className="container">
      <span className="heading-page mt-0">Masters Form</span>
      <div className="mt-4">
        <TabView>
          <TabPanel header="PHC master">
            <GeoMaster/>
          </TabPanel>

          <TabPanel header="User master">
            <UserMaster/>
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};

export default Masters;
